import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ExternalLinkIcon } from 'lucide-react';
const SNAK_URL = 'https://content.snakker.io/snak/Uu3ufW9DaeaXUbhoEBC1RQhcwqpV3EqL/index.html';
interface SnakPlayerProps {
  open: boolean;
  onClose: () => void;
}
export function SnakPlayer({
  open,
  onClose
}: SnakPlayerProps) {
  return <AnimatePresence data-id="element-1174" data-mp="1vpdjcap01elq">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 md:p-8" onClick={onClose} role="dialog" aria-label="Snak player" data-id="element-1175" data-mp="2se2yht98rt40">
          <motion.div initial={{
        scale: 0.96,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.96,
        opacity: 0,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="bg-white rounded-2xl shadow-2xl w-full max-w-md h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-1176" data-mp="3b4kmxln1k2jk">
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 shrink-0" data-id="element-1177" data-mp="30rdjlzkbzi88">
              <div data-id="element-1178" data-mp="35m10bc93f8c9">
                <p className="text-[10px] uppercase tracking-[0.18em] text-[#6C2BD9] font-semibold" data-id="element-1179" data-mp="2qrcyc82wis1e">
                  Live example
                </p>
                <p className="text-sm font-bold text-slate-900" data-id="element-1180" data-mp="2vqps7cs6wzdh">
                  Play the Snak
                </p>
              </div>
              <div className="flex items-center gap-1" data-id="element-1181" data-mp="tyukt9cyvh12">
                <a href={SNAK_URL} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full hover:bg-slate-100 flex items-center justify-center transition-colors" aria-label="Open Snak in a new tab" title="Open in new tab" data-id="element-1182" data-mp="tyb41vz1yyom">
                  <ExternalLinkIcon className="w-4 h-4 text-slate-600" data-id="element-1183" data-mp="eio6cxo92fuw" />
                </a>
                <button onClick={onClose} className="w-9 h-9 rounded-full hover:bg-slate-100 flex items-center justify-center transition-colors" aria-label="Close Snak player" data-id="element-1184" data-mp="1b8oqgjdoc85v">
                  <XIcon className="w-5 h-5 text-slate-600" data-id="element-1185" data-mp="11gj35mydaex0" />
                </button>
              </div>
            </div>
            <iframe src={SNAK_URL} title="Snakker Snak example" className="flex-1 w-full border-0 bg-white" allow="autoplay; fullscreen" data-id="element-1186" data-mp="xexqo2pqw2nc" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}